"use client";

import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import classes from "./SocialSection.module.css";

export default function SocialSection() {
  return (
    <div className={classes.socialIcons}>
      <a
        href="https://www.facebook.com/serverstockuk"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaFacebookF />
      </a>
      <a
        href="https://twitter.com/serverstockuk"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaTwitter />
      </a>
      <a
        href="https://www.linkedin.com/company/serverstockuk/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaLinkedinIn />
      </a>
      {/* <a
        href="https://www.instagram.com/serverstockuk/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaInstagram />
      </a> */}
    </div>
  );
}
